export { DMS_MODULE } from '../constants';
export const NAME = 'WorkInProgress';
export const API_NAME = 'WorkInProgress';
export const CRUMB_LABEL_KEY = 'WorkInProgress';

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };

